export const baseFilters = {
	page: 1,
	paginate: 10,
	defaultUnitFilter: 1000,
	order: "code",
	orderType: "desc",
	appOrderFilter: "",
	businessFilter: "",
	dateFilter: "",
	dateToFilter: "",
	appOrdersStateFilter: "",
	internalCodeFilter: "",
	typeFilter: "",
};

export const appOrdersTableHead = [
	{
		name: "",
		size: "3",
		order: "",
	},
	{
		name: "N° Orden",
		size: "6",
		order: "code",
	},
	{
		name: "Fecha",
		size: "8",
		order: "application_order_date",
	},
	{
		name: "Hora Inicio",
		size: "6",
		order: "start_time",
	},
	{
		name: "Hora Fin",
		size: "6",
		order: "end_time",
	},
	{
		name: "Cant. Productos",
		size: "7",
		order: "products_count",
	},
	{
		name: "Objetivo",
		size: "10",
		order: "target",
	},
	{
		name: "Estado",
		size: "7",
		order: "application_orders_state_name",
	},
	{
		name: "Razón Social",
		size: "10",
		order: "business_name",
	},
	{
		name: "Acción",
		size: "2",
		order: "",
	},
	{
		name: "",
		size: "5",
		order: "",
	},
];
